<aside @dialogReveal #dialog tabindex="-1">
    <!-- This wrapper is needed for IE -->
    <div class="wrapper">
        <div class="button-wrapper">
            <!-- We have the button first, to make sure the button is the first tabable item -->
            <button (click)="close()">
                <app-svg-icon aria-hidden="true" iconName="close" class="icon-close"></app-svg-icon>
                <span class="button-text kk-overflow-ellipsis">{{ 'general.action.close' | translateSafe }}</span>
            </button>
        </div>
        <div class="content">
            <ng-content></ng-content>
        </div>
    </div>
</aside>
